import axios from 'axios'
import qs from "qs";
// import router from '../router'
import {
    apiURL,
    apiGaURL,
    apiJavaURL,
    smsDomain,
    smsURL,
    videoEncodeApi,
    javaExcelApi,
    localStorageKey,
    statisticsURL,
    statisticsJavaURL
} from "./config";
import EventBus from "@/utils/event-bus";
import moment from 'moment';
import alertMixins from "@/mixins/alertMixins";

const onUnauthorized = () => {
    localStorage.removeItem("com.dgmonglab.chodan-vue-adminlevel");
    localStorage.removeItem("com.dgmonglab.chodan-vue-adminrefreshToken");
    localStorage.removeItem("com.dgmonglab.chodan-vue-admintoken");
};

const RESULTCODE = {
    INVALIDE_PARAMETER: "INVALID_PARAMETER",
    SUCCEEDED: "SUCCEEDED",
    ERROR: "ERROR"
}

const RESULTDEFUALTDATA = {data: {Data: {Result: {Info: {status: false, type: null}}}}}
const getResultDefaultData = (type) => {
    let result = Object.assign({}, RESULTDEFUALTDATA)
    result.data.Data.Result.Info.type = type;
    return result;
}
export const setAuthInHeader = token => {
    axios.defaults.headers.common['Authorization'] = token ? `Bearer ${token}` : '';
};

axios.defaults.paramsSerializer = params => {
    return qs.stringify(params, { arrayFormat: 'repeat' });
};

function logout() {
    window.localStorage.clear();
    setAuthInHeader('');
    //history.replaceState(null, null, '/')
    history.go();
    location.replace('/');
}

function clearAdminSession() {
    localStorage.removeItem("com.dgmonglab.rainbow-crm-adminlevel");
    localStorage.removeItem("com.dgmonglab.rainbow-crm-admintoken");
    localStorage.removeItem("com.dgmonglab.rainbow-crm-adminuseTime");
}

function redirectToAuth() {
    clearAdminSession();
    location.href = '/auth';
}

function showStoppedAccountAlert() {
    alertMixins.methods.createAlert({
        content: '정지되어있는 계정입니다.<br>담당 관리자에게 문의해주세요.',
        hide: redirectToAuth,
    });
}

function handleJavaUnauthorized(response) {
    if (!response || response.status !== 401) {
        return false;
    }

    const code = response.data && response.data.code != null ? `${response.data.code}` : '';
    if (code === '-240') {
        alert("탈퇴회원입니다.");
        redirectToAuth();
        return true;
    }
    if (code === '-250') {
        alert("휴먼회원입니다.");
        redirectToAuth();
        return true;
    }
    if (code === '-260') {
        showStoppedAccountAlert();
        return true;
    }

    redirectToAuth();
    return true;
}

export const request = {

    javaGet(path, params = null) {
        return axios.get(`${apiJavaURL + path}`, {params: params})
            .then(res => {
                let now = moment().format("YYYY-MM-DD HH:mm:ss");
                    window.localStorage.setItem(localStorageKey + 'useTime', '"' + String(now) + '"');
                return res;
            }).catch(({response}) => {
                if (handleJavaUnauthorized(response)) {
                    return response;
                }

                return response
            })
    },
    javaPost(path, data) {
        return axios.post(`${apiJavaURL + path}`, data)
            .then(res => {
                let now = moment().format("YYYY-MM-DD HH:mm:ss");
                    window.localStorage.setItem(localStorageKey + 'useTime', '"' + String(now) + '"');
                return res;
            }).catch(({response}) => {
                if (response == undefined) {
                    return response
                }
                if (handleJavaUnauthorized(response)) {
                    return response;
                }
                const {status} = response.data.code;

                if (response == undefined || status === 201 || status === 202 || status === 203) {
                    return onUnauthorized();
                }
                return response
            })
    },
    javaDelete(path, params = null) {
        return axios.delete(`${apiJavaURL + path}`, {data: params})
            .then(res => {
                let now = moment().format("YYYY-MM-DD HH:mm:ss");
                    window.localStorage.setItem(localStorageKey + 'useTime', '"' + String(now) + '"');
                return res;
            }).catch(({response}) => {
                if (handleJavaUnauthorized(response)) {
                    return response;
                }
                const {status} = response.data.code;
                if (status === 201 || status === 202 || status === 203) {
                    return onUnauthorized();
                }
                return response
            })
    },
    javaPut(path, data) {
        return axios.put(`${apiJavaURL + path}`, data)
            .then(res => {
                let now = moment().format("YYYY-MM-DD HH:mm:ss");
                    window.localStorage.setItem(localStorageKey + 'useTime', '"' + String(now) + '"');
                return res;
            }).catch(({response}) => {
                if (handleJavaUnauthorized(response)) {
                    return response;
                }
                const {status} = response.data.code;
                if (status === 201 || status === 202 || status === 203) {
                    return onUnauthorized();
                }
                return response
            })
    },
    javaPatch(path, data) {
        return axios.patch(`${apiJavaURL + path}`, data)
            .then(res => {
                let now = moment().format("YYYY-MM-DD HH:mm:ss");
                    window.localStorage.setItem(localStorageKey + 'useTime', '"' + String(now) + '"');
                return res;
            }).catch(({response}) => {
                if (handleJavaUnauthorized(response)) {
                    return response;
                }
                const {status} = response.data.code;
                if (status === 201 || status === 202 || status === 203) {
                    return onUnauthorized();
                }
                return response
            })
    },

    get(path, params = null) {
        return axios
                .get(`${apiURL + path}`, {params: params})
                .then((res) => {
                    let now = moment().format("YYYY-MM-DD HH:mm:ss");
                    window.localStorage.setItem(localStorageKey + 'useTime', '"' + String(now) + '"');
                    if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                        alert("문제가 발생했습니다. 다시 시도해주세요.");
                        router.push("/");
                        return res;
                    } else if (res.data.Data.Result.Info.type === -401) {
                        window.localStorage.removeItem(localStorageKey + 'token');
                        window.localStorage.removeItem(localStorageKey + 'useTime');
                        window.localStorage.removeItem(localStorageKey + 'level');
                    } else {
                        if (res.data.Data.Result.Info.type === -270) {
                            logout();
                        } else {
                            EventBus.$emit("resetLogoutTimer", true);
                            return res;
                        }
                    }
                })
                .catch(({response}) => {
                    const {status} = response;
                    if (status === 400 || status === 401) {
                        return onUnauthorized();
                    } else if (status === Errored) {
                        alert("잘못된 정보입니다.");
                    }
                    throw Error(response);
                });
    },
    post(path, data) {
        return axios
                .post(`${apiURL + path}`, data)
                .then((res) => {
                    let now = moment().format("YYYY-MM-DD HH:mm:ss");
                    window.localStorage.setItem(localStorageKey + 'useTime', '"' + String(now) + '"');
                    if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                        alert("문제가 발생했습니다. 다시 시도해주세요.");
                        EventBus.$emit("changeLoading", false);
                        // //location.href = '/'
                        return res;
                    } else {
                        if (res.data.Data.hasOwnProperty('Result') && res.data.Data.Result.Info.type === -270) {
                            logout();
                        } else if (res.data.Data.hasOwnProperty('Result') && res.data.Data.Result.Info.type === -401) {
                            window.localStorage.removeItem(localStorageKey + 'token');
                            window.localStorage.removeItem(localStorageKey + 'useTime');
                            window.localStorage.removeItem(localStorageKey + 'level');
                        } else {
                            EventBus.$emit("resetLogoutTimer", true);
                            return res;
                        }
                    }
                })
                .catch(({response}) => {
                    EventBus.$emit("changeLoading", false);
                    //location.href = '/'
                    const {status} = response || {status: null};
                    if (status === 400 || status === 401) {
                        return onUnauthorized();
                    }
                    // throw Error(response);
                    return response;
                });
    },
    smsPost(path, data) {
        return axios
                .post(`${smsURL + path}`, data)
                .then((res) => {
                    let now = moment().format("YYYY-MM-DD HH:mm:ss");
                    window.localStorage.setItem(localStorageKey + 'useTime', '"' + String(now) + '"');
                    if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                        alert("문제가 발생했습니다. 다시 시도해주세요.");
                        EventBus.$emit("changeLoading", false);
                        //location.href = '/'
                        return res;
                    } else {
                        if (res.data.Data.hasOwnProperty('Result') && res.data.Data.Result.Info.type === -270) {
                            logout();
                        } else {
                            EventBus.$emit("resetLogoutTimer", true);
                            return res;
                        }
                    }
                })
                .catch(({response}) => {
                    EventBus.$emit("changeLoading", false);
                    //location.href = '/'
                    const {status} = response || {status: null};
                    if (status === 400 || status === 401) {
                        return onUnauthorized();
                    }
                    throw Error(response);
                });
    },
    encodeVideo(data) {
        let config = {
            headers: {
                "Content-Type": `application/json`,
                Authorization: "",
            },
        };
        return axios
                .post(videoEncodeApi, JSON.stringify(data), config)
                .then((res) => {
                    if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                        alert("문제가 발생했습니다. 다시 시도해주세요.");
                        return res;
                    } else {
                        if (res.data.Data.hasOwnProperty('Result') && res.data.Data.Result.Info.type === -270) {
                            logout();
                        } else {
                            EventBus.$emit("resetLogoutTimer", true);
                            return res;
                        }
                    }
                })
                .catch(({response}) => {
                    const {status} = response || {status: null};
                    if (status === 400 || status === 401) {
                        return onUnauthorized();
                    } else if (status != null) {
                        alert("잘못된 정보입니다.");
                    }
                    let result = getResultDefaultData(status);
                    //throw Error(response)
                    return result;
                });
    },
    javaExcelGet(path, params) {
        return axios.get(`${javaExcelApi + path}`, {params: params}).then((res) => {
            if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                alert("문제가 발생했습니다. 다시 시도해주세요.");
                //location.href = '/'
                return res;
            }
            if (res.data.ResultCode == -100) {
                alert("문제가 발생했습니다. 다시 시도해주세요.");
                //location.href = '/'
                return res;
            } else {
                EventBus.$emit("resetLogoutTimer", true);
                return res;
            }
        }).catch(({response}) => {
            const {status} = response;
            if (status === 400 || status === 401) {
                return onUnauthorized();
            } else if (status === Errored) {
                alert("잘못된 정보입니다.");
            }
            throw Error(response);
        });
    },
    javaExcelPost(path, params) {
        return axios.post(`${javaExcelApi + path}`, params).then((res) => {
            if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                alert("문제가 발생했습니다. 다시 시도해주세요.");
                // //location.href = '/'
                return res;
            } else {
                EventBus.$emit("resetLogoutTimer", true);
                return res;
            }
        }).catch(({response}) => {
            // location.href = '/'
            const {status} = response;
            if (status === 400 || status === 401) {
                return onUnauthorized();
            } else if (status === Errored) {
                alert("잘못된 정보입니다.");
            }
            throw Error(response);
        });
    },
    javaExcelPut(path, params) {
        return axios.put(`${javaExcelApi + path}`, params).then((res) => {
            if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                // alert("문제가 발생했습니다. 다시 시도해주세요.");
                // location.href = '/'
                return res;
            } else {
                EventBus.$emit("resetLogoutTimer", true);
                return res;
            }
        }).catch(({response}) => {
            // location.href = '/'
            const {status} = response;
            if (status === 400 || status === 401) {
                return onUnauthorized();
            } else if (status === Errored) {
                alert("잘못된 정보입니다.");
            }
            throw Error(response);
        });
    },
    javaExcelDelete(path, params) {
        return axios.delete(`${javaExcelApi + path}`, {params: params}).then((res) => {
            if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                alert("문제가 발생했습니다. 다시 시도해주세요.");
                location.href = '/'
                return res;
            } else {
                EventBus.$emit("resetLogoutTimer", true);
                return res;
            }
        }).catch(({response}) => {
            location.href = '/'
            const {status} = response;
            if (status === 400 || status === 401) {
                return onUnauthorized();
            } else if (status === Errored) {
                alert("잘못된 정보입니다.");
            }
            throw Error(response);
        });
    },
    gaPost(path, data) {
        return axios
                .post(`${apiGaURL + path}`, data)
                .then((res) => {
                    let now = moment().format("YYYY-MM-DD HH:mm:ss");
                    window.localStorage.setItem(localStorageKey + 'useTime', '"' + String(now) + '"');
                    if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                        alert("문제가 발생했습니다. 다시 시도해주세요.");
                        EventBus.$emit("changeLoading", false);
                        // location.href = '/'
                        return res;
                    } else {
                        if (res.data.Data.hasOwnProperty('Result') && res.data.Data.Result.Info.type === -270) {
                            logout();
                        } else if (res.data.Data.hasOwnProperty('Result') && res.data.Data.Result.Info.type === -401) {
                            window.localStorage.removeItem(localStorageKey + 'token');
                            window.localStorage.removeItem(localStorageKey + 'useTime');
                            window.localStorage.removeItem(localStorageKey + 'level');
                        } else {
                            EventBus.$emit("resetLogoutTimer", true);
                            return res;
                        }
                    }
                })
                .catch(({response}) => {
                    throw Error(response);
                });
    },
    getStatistics(path, params = null) {
        return axios
                .get(`${statisticsURL + path}`, {params: params})
                .then((res) => {

                    let now = moment().format("YYYY-MM-DD HH:mm:ss");
                    window.localStorage.setItem(localStorageKey + 'useTime', '"' + String(now) + '"');
                    if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                        alert("문제가 발생했습니다. 다시 시도해주세요.");
                        // router.push("/");
                        return res;
                    } else if (res.data.Data.Result.Info.type === -401) {
                        window.localStorage.removeItem(localStorageKey + 'token');
                        window.localStorage.removeItem(localStorageKey + 'useTime');
                        window.localStorage.removeItem(localStorageKey + 'level');
                    } else {
                        if (res.data.Data.Result.Info.type === -270) {
                            logout();
                        } else {
                            EventBus.$emit("resetLogoutTimer", true);
                            return res;
                        }
                    }
                })
                .catch(({response}) => {
                    const {status} = response;
                    if (status === 400 || status === 401) {
                        return onUnauthorized();
                    } else if (status === Errored) {
                        alert("잘못된 정보입니다.");
                    }
                    throw Error(response);
                });
    },
    postStatistics(path, data) {
        return axios
                .post(`${statisticsURL + path}`, data)
                .then((res) => {
                    let now = moment().format("YYYY-MM-DD HH:mm:ss");
                    window.localStorage.setItem(localStorageKey + 'useTime', '"' + String(now) + '"');
                    if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                        alert("문제가 발생했습니다. 다시 시도해주세요.");
                        EventBus.$emit("changeLoading", false);
                        // location.href = '/'
                        return res;
                    } else {
                        if (res.data.Data.hasOwnProperty('Result') && res.data.Data.Result.Info.type === -270) {
                            logout();
                        } else if (res.data.Data.hasOwnProperty('Result') && res.data.Data.Result.Info.type === -401) {
                            window.localStorage.removeItem(localStorageKey + 'token');
                            window.localStorage.removeItem(localStorageKey + 'useTime');
                            window.localStorage.removeItem(localStorageKey + 'level');
                        } else {
                            EventBus.$emit("resetLogoutTimer", true);
                            return res;
                        }
                    }
                })
                .catch(({response}) => {
                    // EventBus.$emit("changeLoading", false);
                    // location.href = '/'
                    // const {status} = response || {status: null};
                    // if (status === 400 || status === 401  ) {
                    //     return onUnauthorized();
                    // } else if (status === Errored) {
                    //     alert("잘못된 정보입니다.");
                    // }
                    // throw Error(response);
                });
    },
    getJavaStatistics(path, params = null) {
        return axios.get(`${statisticsJavaURL + path}`, {params: params})
            .then(res => {
                let now = moment().format("YYYY-MM-DD HH:mm:ss");
                window.localStorage.setItem(localStorageKey+'useTime', '"'+String(now)+'"');
                return res;
            }).catch(({response}) => {
                if (handleJavaUnauthorized(response)) {
                    return response;
                }

                return response
            })
    },
    postJavaStatistics(path, data) {
        return axios
            .post(`${statisticsJavaURL + path}`, data)
            .then(res => {
                let now = moment().format("YYYY-MM-DD HH:mm:ss");
                window.localStorage.setItem(localStorageKey+'useTime', '"'+String(now)+'"');
                return res;
            }).catch(({response}) => {
                if (response == undefined) {
                    return response
                }
                if (handleJavaUnauthorized(response)) {
                    return response;
                }
                const {status} = response.data.code;

                if (response == undefined || status === 201 || status === 202 || status === 203) {
                    return onUnauthorized();
                }
                return response
            })
    },
    putJavaStatistics(path, data) {
        return axios.put(`${statisticsJavaURL + path}`, data)
            .then(res => {
                let now = moment().format("YYYY-MM-DD HH:mm:ss");
                window.localStorage.setItem(localStorageKey+'useTime', '"'+String(now)+'"');
                return res;
            }).catch(({response}) => {
                if (handleJavaUnauthorized(response)) {
                    return response;
                }
                const {status} = response.data.code;
                if (status === 201 || status === 202 || status === 203) {
                    return onUnauthorized();
                }
                return response
            })
    },
    deleteJavaStatistics(path, params = null) {
        return axios.delete(`${statisticsJavaURL + path}`, {data: params})
            .then(res => {
                let now = moment().format("YYYY-MM-DD HH:mm:ss");
                window.localStorage.setItem(localStorageKey+'useTime', '"'+String(now)+'"');
                return res;
            }).catch(({response}) => {
                if (handleJavaUnauthorized(response)) {
                    return response;
                }
                const {status} = response.data.code;
                if (status === 201 || status === 202 || status === 203) {
                    return onUnauthorized();
                }
                return response
            })
    },
    downloadNestExcel(path, params) {
        return axios.get(`${statisticsURL + path}`, {
            params,
            responseType: 'blob',
        }).then((res) => {
            return res;
        }).catch(({response}) => {
            const {status} = response;
            if (status === 400 || status === 401) {
                return onUnauthorized();
            } else if (status === Errored) {
                alert("잘못된 정보입니다.");
            }
            throw Error(response);
        });
    },
    multipartPost(path, data, files = [], keyName = '', fileName= 'file') {
        let token = axios.defaults.headers.common['Authorization'];

        let config = {
            headers: {
                "Content-Type": `multipart/form-data`,
                Authorization: token,
            },
        };

        const formData = new FormData();
        if(keyName != '') {
            formData.append([keyName], JSON.stringify(data));
        }


        for (let i = 0; i < files.length; i++) {
            if (files[i].raw !== undefined) {
                formData.append(fileName, files[i].raw);
            }
        }

        return axios.post(`${apiJavaURL + path}`, formData, config)
            .then(res => {
                if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                    alert("문제가 발생했습니다. 다시 시도해주세요.");
                    return res;
                } else return res;
            })
            .catch((response) => {
                if (response && response.data && response.data.code) {
                    if (response.data.code != '-202' && response.data.code != '-203') {
                        return response
                    } else {
                        onUnauthorized();
                    }
                }
                return response.response;
            })
    },
    multipartGet(path, data, files = [], keyName = '', fileName= 'file') {
        let token = axios.defaults.headers.common['Authorization'];

        let config = {
            headers: {
                "Content-Type": `multipart/form-data`,
                Authorization: token,
            },
        };

        const formData = new FormData();
        if(keyName != '') {
            formData.append([keyName], JSON.stringify(data));
        }


        for (let i = 0; i < files.length; i++) {
            if (files[i].raw !== undefined) {
                formData.append(fileName, files[i].raw);
            }
        }

        return axios.get(`${apiJavaURL + path}`, formData, config)
            .then(res => {
                if (res.data.ResultCode === RESULTCODE.INVALIDE_PARAMETER) {
                    alert("문제가 발생했습니다. 다시 시도해주세요.");
                    return res;
                } else return res;
            })
            .catch((response) => {
                if (response && response.data && response.data.code) {
                    if (response.data.code != '-202' && response.data.code != '-203') {
                        return response
                    } else {
                        onUnauthorized();
                    }
                }
                return response.response;
            })
    },
};
